import React from "react";

import { Badge } from "../../../../../components/Badge";
import { CORPORATE_ACTION_LOCK_REASON } from "./constants";
import { buildCorporateActionDisplay } from "./corporateActionDisplay";
import { CorporateActionItemProps } from "./types";
import {
  ActionNote,
  CardDate,
  CardDetails,
  CardHeading,
  CardPrimaryRow,
  CardRow,
  CorrectionNote,
  LockedChip,
  TypeBadge,
} from "./styles";

/** The mobile counterpart of `CorporateActionRow`: no menu, since an action has no correction to offer here. */
export const CorporateActionCard: React.FC<CorporateActionItemProps> = ({
  entry,
}) => {
  const {
    dateText,
    typeLabel,
    positionText,
    stateLabel,
    stateVariant,
    stateNote,
    detailsText,
  } = buildCorporateActionDisplay(entry);

  return (
    <CardRow>
      <CardHeading>
        <CardDate>{dateText}</CardDate>
        <TypeBadge $tone="neutral">{typeLabel}</TypeBadge>
        <Badge variant={stateVariant} style="soft" size="small">
          {stateLabel}
        </Badge>
        <LockedChip
          role="note"
          title={CORPORATE_ACTION_LOCK_REASON}
          aria-label={CORPORATE_ACTION_LOCK_REASON}
        >
          Locked
        </LockedChip>
      </CardHeading>
      <CardPrimaryRow>{positionText}</CardPrimaryRow>
      {detailsText && <CardDetails>{detailsText}</CardDetails>}
      {stateNote && <ActionNote>{stateNote}</ActionNote>}
      <CorrectionNote>{CORPORATE_ACTION_LOCK_REASON}</CorrectionNote>
    </CardRow>
  );
};
